import axios from 'axios';
import type { SharePresetRequestBody, SharePresetResponseBody, SharePresetToUseRequestBody, SharePresetToUseResponseBody } from '../types/api/preset';
import { makeInstanceConfig } from './axiosConfig';
import type { ApiContext } from './types';
export function createShareApi(ctx: ApiContext) {
  const BASE = `/v6/data-grid/${ctx.gridCode}`;
  const instanceConfig = makeInstanceConfig(ctx.presetInstanceId);
  return {
    sharePreset: (params: SharePresetRequestBody) => axios.post<SharePresetResponseBody>(`${BASE}/share-preset`, params, instanceConfig).then(response => response.data),
    // Error is handled in useSharePreset hook
    sharePresetToUser: (presetId: string, params: SharePresetToUseRequestBody) => axios.post<SharePresetToUseResponseBody>(`${BASE}/preset/${presetId}/share`, params, instanceConfig).then(response => response.data) // Error is handled in useSharePresetToUser hook
  };
}